import { useEffect, useState, useCallback } from 'react';

import { KPI } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { computeKwickInvoicesSiteIds } from './kwick-invoices-resolver.utils';

// const ENV = (import.meta as any).env;

export const KwickInvoicesResolver = () => {
  const params: any = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const metadata = useSelector((state: any) => state.metadata);
  const kpi = useSelector((state: any) => state.kpi);

  // const [ context, setContext ] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const InvoicesInit = useCallback(async () => {
    // Don't trigger if ID is not set in URL yet
    if (!params?.id) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const sitesIds = computeKwickInvoicesSiteIds(metadata, pathSegment, params);
    if (sitesIds.length === 0) {
      setIsLoading(false);
      return;
    }

    if ( sitesIds.length < 1 ) {
      return;
    }

    // Build communityFilter for single-community context
    const communityFilter = pathSegment?.includes('community') && !pathSegment?.includes('communities')
      ? { communityId: params.id, sites: metadata?.entities?.sites || [] }
      : undefined;

    // Build memberFilter for member context only.
    // Site view should show ALL invoices (all members), so no filter is applied there.
    const memberFilter = pathSegment?.includes('member')
      ? {
          memberId: params.id,
          sites: (metadata?.selectedEntity?.sites || []).map((site: any) => ({
            siteId: site.siteId,
            memberId: params.id,
            memberChangelog: [{
              memberId: params.id,
              startDate: site.startDate || site.joinDate,
              endDate: site.endDate || site.leaveDate,
            }],
          })),
        }
      : undefined;

    // Token auto-injected by httpService interceptor. This resolver only triggers
    // the fetch; the invoices (or the null "no data" signal) are read from the
    // store by <Billing>, which owns the empty/error + retry UI.
    await dispatch(KPI.FetchKwickInvoicesAsync({ siteIds: sitesIds, communityFilter, memberFilter }) as any);
    setIsLoading(false);
    // Note: kpi?.KwickInvoicesAsyncStatus is intentionally not in deps to avoid infinite loop
    // (it changes as a result of this function running). params.id is used instead of params.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata, pathSegment, params.id, dispatch]);

  useEffect(() => {
    InvoicesInit();
  }, [InvoicesInit]);

  // Removed window bridge; refresh via thunk from components

  // Data-only resolver: always render nothing. The previous implicit
  // `return undefined` (when an error was flagged) threw React's "Nothing was
  // returned from render" and blanked the whole view. The empty/error state with
  // a Retry action is rendered by <Billing> off `kpi.kwickInvoices === null`.
  return null;
};
